<template> 
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div> 
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px;height: auto !important;"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Invoice Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button
                size="sm"
                variant="dark"
                id="addButtonLoaderpro"
                @click="proceedToManualInv"
                >New Billing</b-button
              >
            </b-nav-form>
          </b-navbar-nav> -->
           <b-navbar-nav class="pull-right mr-auto">
                <b-nav-form>
                
                  <ClientCard />
                   <ShipmentTrackCard />
                </b-nav-form>
              </b-navbar-nav>
        </b-navbar>

        <b-card>
          <md-layout md-gutter>
            <md-layout md-flex="30" md-flex-small="100">
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              >
              </date-range-picker>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30" md-flex-small="100">
              <model-list-select
                :list="clientMaster"
                id="clientNamenew"
                class="mt-2"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30" md-flex-small="100">
              <b-form-input
                class="mt-2"
                :formatter="capitalizeAll"
                v-model="InvoiceNoFilter"
                placeholder=" Invoice Number"
              ></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="SBFilter"
                placeholder=" Shipping Bill No."
              ></b-form-input>
            </md-layout> -->
            <!-- <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="ContainerFilter"
                placeholder=" Container  No."
              ></b-form-input>
            </md-layout> 
            <md-layout md-flex="15">
              <b-form-input :formatter="capitalizeAll"
                class="ml-3"
                v-model="shiperInvFilter"
                placeholder=" Shipper Inv No."
              ></b-form-input>
            </md-layout>  -->
          </md-layout>

          <md-layout md-gutter class="mt-3">
            <md-layout md-flex="30" md-flex-small="100">
              <b-form-input
                :formatter="capitalizeAll"
                class="mt-2"
                v-model="assignmentFilter"
                placeholder=" Assignment No."
              ></b-form-input>
            </md-layout>
            <md-layout md-flex="5"></md-layout>

            <md-layout md-flex="30" md-flex-small="100">
              <model-list-select
                :list="invoiceStatusdataList"
                v-model="invstatusFilter"
                option-value="inv"
                class="mt-2"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30" md-flex-small="100">
              <model-list-select
                class="mt-2"
                :list="assignmentStatusdataList"
                v-model="assignstatusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Assignment Status"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
              ></model-list-select>
            </md-layout> -->
            <!-- <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="15">
              <model-list-select
                class="ml-3"
                :list="invoiceStatusList"
                v-model="statusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </md-layout> -->
            <!-- <md-layout md-flex="50">

            <b-form-group   class="mt-3" >
                  <b-form-checkbox-group
                    id="checkbox-group-1"
                  v-model="jobRecFilter"
                    :options="jobRecList"
                  
                    name="flavour-1"
                  ></b-form-checkbox-group>
                </b-form-group>
            </md-layout> -->
          </md-layout>

          <md-layout md-gutter class="mt-3">
            <md-layout md-flex="30" md-flex-small="100">
              <b-form-input
                class="mt-2"
                :formatter="capitalizeAll"
                v-model="CommonFilter"
                placeholder="Common BL/Container Search"
              ></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="justify-content-center mt-4">
            
            <b-button size="sm" @click="filterSearch" variant="outline-primary"
              >Search</b-button
            >

            <b-button size="sm" class="ml-3" @click="clearFilter" variant="outline-info"
              >clear</b-button
            >
            <!-- <b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="getReports('BILLING_SCREEN')"
              variant="outline-info"
              >Export as Excel</b-button
            >
<b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="getReports('BILLING_SCREEN_ALL')"
              variant="outline-info"
              >Export All Execution </b-button
            >
             -->
          </md-layout>
          <!-- <div class="gutr"></div> -->
        </b-card>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="20"
              style="margin: 0px"
              align="right"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>

          <div class="mt-4">
            <div>
              <!-- <b-button
                class="pull-right mb-1"
                v-if="invoiceTallyList.length > 0"
                @click="getReports('INVOICE_BILLING')"
                size="sm"
                center
                variant="warning"
                >Export as Excel</b-button
              > -->

              <b-button
                class="pull-right mb-1"
                v-if="invoiceTallyList.length > 0"
                :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                @click="getReports('INVOICE_BILLING', 'Export As Excel')"
                size="sm"
                variant="warning"
              >
                {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export As Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
                class="pull-right mr-1 mb-1"
                v-if="invoiceTallyList.length > 0"
                @click="getReports('INVOICE_BILLING_CONTAINERWISE')"
                size="sm"
                center
                variant="warning"
                >Export ContainerWise Report</b-button
              > -->
              <b-button
                class="pull-right mr-1 mb-1"
                v-if="invoiceTallyList.length > 0"
                :disabled="
                  ExcelContainerWiseBtnName != 'Export ContainerWise Report'
                    ? true
                    : false
                "
                @click="
                  getReports(
                    'INVOICE_BILLING_CONTAINERWISE',
                    'Export ContainerWise Report'
                  )
                "
                size="sm"
                variant="warning"
              >
                {{ ExcelContainerWiseBtnName }}
                <b-spinner
                  v-if="ExcelContainerWiseBtnName != 'Export ContainerWise Report'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
                v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
                center
                size="sm"
                class="ml-1"
                @click="getReportsReverse('PENDING_REVERSE_BILLING')"
                variant="outline-info"
                >Export Pending Reverse Bill
                <b style="color:red">(COUNT :
                  {{ $store.getters["common/getAllPendingReverseTallyList"] }})
                  
                </b>
                
              </b-button> -->

              <b-button
                class="pull-right mr-1 mb-1"
                v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
                :disabled="
                  ExcelPendingReverseBtnName != 'Export Pending Reverse Bill'
                    ? true
                    : false
                "
                @click="
                  getReportsReverse(
                    'PENDING_REVERSE_BILLING',
                    'Export Pending Reverse Bill'
                  )
                "
                size="sm"
                variant="warning"
              >
                {{ ExcelPendingReverseBtnName }}
                <b-spinner
                  v-if="ExcelPendingReverseBtnName != 'Export Pending Reverse Bill'"
                  small
                  label="Small Spinner"
                ></b-spinner
                ><b style="color: red"
                  >(COUNT : {{ $store.getters["common/getAllPendingReverseTallyList"] }})
                </b>
              </b-button>
               <b-button
                class="ml-3"
                :disabled="ExcelBSJBtnName != 'Failed SE REPORT' ? true : false"
                @click="
                  getFailedSalesExpenseLogList('Excell')
                "
                size="sm"
                variant="outline-info"
              >
                {{ ExcelBSJBtnName }}
                <b-spinner
                  v-if="ExcelBSJBtnName != 'Failed SE REPORT'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

                <b-button
                class="ml-3"
                :disabled="ExcelJVBtnName != 'JV REPORT' ? true : false"
                @click="
                  getJVList('Excell')
                "
                size="sm"
                variant="outline-info"
              >
                {{ ExcelJVBtnName }}
                <b-spinner
                  v-if="ExcelJVBtnName != 'JV REPORT'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

              <b-button
                class="pull-right mb-1 mr-1"
                @click="newReverseTally()"
                size="sm"
                variant="warning"
              >
                New Reverse Tally
              </b-button>
              
              <span
                v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                "
                ><br />Updated Data From :
                <span style="color: blue"
                  ><u>{{ "25-Nov-2022" }}</u></span
                ></span
              >
            </div>
          </div>

          <br />

          <div class="gutr">
            <h5 class="text-muted pull-right mt-2">
              <small v-if="isLoading == false">{{ totalTallyCount }} Entries</small>
            </h5>
          </div>
          <!-- <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalTallyCount }} Entries</small>
          </h5> -->
          <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="100">
              <b-form-input :formatter="capitalizeAll"
                v-model="filter"
                placeholder="Search Assignment"
                @input="viewFFExportFCL('0','1')"
              ></b-form-input>
            </md-layout>
          </md-layout>-->
          <div class="table-responsive tableMain gutr">
            <b-table
              show-empty
              stacked="md"
              :items="invoiceTallyList"
              :fields="InvoiceFields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <!-- <md-icon>{{
                  row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon> -->
                <!-- {{row1.item}} -->
                <b>{{ row1.item.jobNo }}</b>
                <br />

                <!-- <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" || row1.item.shipmentType == "Sea_Shipment" ? "Sea" : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                >
                <br /> -->
                <!-- <span
                  >Assignment Dt. :
                  {{ row1.item.assignmentDate | moment }}</span
                >
                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> -->
                <!-- <br /> -->
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showInvoiceDet(row1.item)"
                  variant="outline-info"
                  >Item Data</b-button
                >
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <br />
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.jobNo"
                />
                <InvExpSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row1.item.jobNo"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.jobNo"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <ContainerSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.jobNo"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.jobNo"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.jobNo"
                  />
                 <RejectInvTallyBillSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Invoice Rejection Log Summary Job No - ' + row1.item.jobNo"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.jobNo"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <!-- {{row1.item}} -->

                <!-- <h7 class="mt-2" v-if="row1.item.splitFromId!='0'"><b-badge variant="info">Split of {{row1.item.splitFromNo}}</b-badge> </h7> -->
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' && row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.clientName }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.clientName }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.clientName }}
                  <br />
                </b>
              </template>
              <template slot="Status" slot-scope="row123">
                <b v-if="row123.item.Status != '' && row123.item.Status != null">
                  <!-- Hello -->
                  <span v-if="row123.item.Status == 'Active'" style="color: green"
                    >Active</span
                  >
                  <span v-if="row123.item.Status == 'Inactive'" style="color: red"
                    >In-Active</span
                  >
                  <!-- {{row123.item.Status}} --> </b
                ><br />
                <!-- {{row123.item.manualBilling}} -->
                <b
                  v-if="
                    row123.item.manualBilling != '' && row123.item.manualBilling != null
                  "
                >
                  {{ row123.item.manual_status }}
                  <!-- <span v-if="row123.item.manualBilling == '0'"
                    >Assignment Billing</span
                  >
                  <span v-if="row123.item.manualBilling == '1'"
                    >Direct Billing</span
                  >
                  <span v-if="row123.item.manualBilling == '3'"
                    >Third party Or Others Billing</span
                  > -->
                </b>
              </template>
              <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')"
                  >FF :-
                  {{ row2.item.ffInvoiceClosed == "1" ? "Received" : "Not-Received" }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')"
                  >CC :-
                  {{ row2.item.ccInvoiceClosed == "1" ? "Received" : "Not-Received" }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')"
                  >TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1" ? "Received" : "Not-Received"
                  }}</span
                >
              </template>

              <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.BillingSeries">
                  <b
                    ><u>
                      <a
                        style="color: blue"
                        v-if="
                          row1000.item.BillingSeries && row1000.item.invoice_pdf == 'Yes'
                        "
                        href="javascript:void(0)"
                        @click="openSignedDocument(`ASSIGNMENT_UPLOADS/Common_Invoices_doc/${row1000.item.BillingSeries.replaceAll('/', '_')}.pdf`)"
                        >{{ row1000.item.BillingSeries }}</a
                      >
                      <a
                        v-else-if="
                          row1000.item.BillingSeries && row1000.item.invoice_pdf == 'No'
                        "
                      >
                        {{ row1000.item.BillingSeries }}
                      </a>
                    </u></b
                  ><br />
                  <span v-if="row1000.item.invoice_pdf == 'Yes'"
                    ><b :style="'color:black'">PDF : </b>
                    <b-badge variant="success"
                      ><b>{{ row1000.item.invoice_pdf }}</b></b-badge
                    ><br
                  /></span>
                  <span v-if="row1000.item.invoice_pdf == 'No'"
                    ><b :style="'color:black'">PDF : </b>
                    <b-badge variant="danger"
                      ><b>{{ row1000.item.invoice_pdf }}</b></b-badge
                    ><br
                  /></span>
                  <!-- <span
                    v-for="(item3, index) in row1000.item.BillingSeries.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  > -->
                </div>
                <span v-else>-----------</span>

                <b-button
                  @click="
                    proceedBilling(
                      row1000.item.allModuleId,
                      row1000.item.newContainerFlow,
                      row1000.item.isConsolidation,
                      row1000.item.mainSalesSeries,
                      row1000.item.BillingSeries
                    )
                  "
                  variant="outline-primary"
                  size="sm"
                  class="mt-1"
                  >{{ "Show Invoice" }}</b-button
                >
              </template>
              <!-- <template slot="mainEnquiryId" slot-scope="row15">
                <b-button
                  @click="
                     proceedBilling(
                      row15.item.allModuleId,
                      row15.item.newContainerFlow,
                      row15.item.isConsolidation,
                      row15.item.mainSalesSeries
                    )
                  "
                  variant="primary"
                  size="sm"
                  >{{
                    row15.item.finalBillingCompleted == "1"
                      ? "Show Billing"
                      : "Proceed To Billing"
                  }}</b-button
                >
                <br />
                <b-badge
                  variant="warning"
                  v-if="row15.item.isConsolidation == '1'"
                  >Consolidation</b-badge
                >
              
                <b-badge
                  variant="success"
                  v-if="row15.item.finalBillingCompleted == '1'"
                  >Billing Completed</b-badge
                >
                <b-badge v-else variant="danger">Billing In-complete</b-badge>

                <br />

                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  v-if="row15.item.finalBillingCompleted != '1'"
                  size="sm"
                  @click="validateBilling(row15.item.allModuleId,row15.item.jobType)"
                  variant="outline-info"
                  >Close Billing</b-button
                >
<span style="color:green" v-if="row15.item.assignmentCloseReason">{{row15.item.assignmentCloseReason}}</span>


              </template> -->
            </b-table>
          </div>
        </div>

        <div>
          <b-pagination
            limit="5"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Submit Your Reason"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <h4 class="error" v-if="incompleteJobBill">
        <small>Invoice Not added for </small> {{ incompleteJobBill }}
        <small> Please Kindly Check..!</small>
      </h4>

      <form ref="form">
        <b-form-group
          label="Reason for closing assignment billing"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="closingReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>

      <b-button
        :disabled="closingReason ? false : true"
        variant="success"
        @click="closeBillOk"
      >
        Confirm & Close Billing</b-button
      >
      <b-button @click="closeModalConfirm" variant="danger" class="pull-right">
        Cancel</b-button
      >
    </b-modal>
    <b-modal
      id="otherTallyInvCharges-modal"
      ref="otherTallyInvCharges-modal"
      :title="modal_title + modal_JobNo"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <table id="tpt" class="table table-bordered">
              <thead>
                <tr>
                  <th>SN.</th>
                  <th>Particulars</th>
                  <th>Split Status</th>
                  <th>Quantity</th>
                  <th>Barcode</th>
                  <th>HSNCode</th>
                  <th>Amount</th>
                  <th>GST Rate</th>
                  <th>IGST Amt</th>
                  <th>CGST Amt</th>
                  <th>SGST Amt</th>
                  <th>Cest Rt/Amt</th>

                  <th>Amt</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in InvItemist" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>{{ item1.PrdDesc }}</td>
                  <td>
                    <b-button
                      v-if="item1.SplitStatus=='YES'"
                    @click="
                      showInvoiceSplitDet(
                        item1,
                        'Invoice',
                        1,
                        item1.InvDet.inv_no,
                        item1.AssNo,
                        'Inv'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item1.SplitStatus }}</b-button>
                    <b v-else >{{ item1.SplitStatus }}</b></td>
                  <td>{{ item1.Qty }}</td>
                  <td>{{ item1.Barcde }}</td>
                  <td>{{ item1.HsnCd }}</td>
                  <td>
                    {{ item1.TotAmt }}
                  </td>
                  <td>{{ item1.GstRt }}</td>
                  <td>
                    {{ item1.IgstAmt }}
                  </td>
                  <td>{{ item1.CgstAmt }}</td>
                  <td>{{ item1.SgstAmt }}</td>
                  <td>{{ item1.CesRt }} / {{ item1.CesAmt }}</td>
                  <td>{{ item1.AssAmt }}</td>
                  <td>{{ item1.TotItemVal }} {{ item1.OrgCntry }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 text-center">
            <center>
              <b-button
                @click="hideInvoiceDet"
                style="font-size: 11px"
                size="sm"
                class="mt-1"
                variant="danger"
              >
                Close</b-button
              >
            </center>
          </div>
        </div>
      </div>
    </b-modal>
     <b-modal
      id="otherTallyInvSplitCharges-modal"
      ref="otherTallyInvSplitCharges-modal"
      :title="modal_title + modal_JobNo"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    > <CustomLoader v-if="isLoadinghide" :width="70"></CustomLoader>
      <div class="row">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <table id="tpt" class="table table-bordered">
              <thead>
                <tr>
                  <th>SN.</th>
                  <th>Particulars</th>
                  <th>Quantity</th>
                  <th>Barcode</th>
                  <th>HSNCode</th>
                  <th>Amount</th>
                  <th>GST Rate</th>
                  <th>IGST Amt</th>
                  <th>CGST Amt</th>
                  <th>SGST Amt</th>
                  <th>Cest Rt/Amt</th>

                  <th>Amt</th>
                  <th>Total</th>
                  <th>JOB</th>
                  <th>JOB AMT</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in InvItemSplitList" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>{{ item1.PrdDesc }}</td>
                  <td>{{ item1.Qty }}</td>
                  <td>{{ item1.Barcde }}</td>
                  <td>{{ item1.HsnCd }}</td>
                  <td>
                    {{ item1.TotAmt }}
                  </td>
                  <td>{{ item1.GstRt }}</td>
                  <td>
                    {{ item1.IgstAmt }}
                  </td>
                  <td>{{ item1.CgstAmt }}</td>
                  <td>{{ item1.SgstAmt }}</td>
                  <td>{{ item1.CesRt }} / {{ item1.CesAmt }}</td>
                  <td>{{ item1.AssAmt }}</td>
                  <td>{{ item1.TotItemVal }} {{ item1.OrgCntry }}</td>
                  <td>{{ item1.JOBNO }}</td>
                  <td>{{ item1.JOBAMT }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12 text-center">
            <center>
              <b-button
                @click="hideInvoiceSplitDet"
                style="font-size: 11px"
                size="sm"
                class="mt-1"
                variant="danger"
              >
                Close</b-button
              >
            </center>
          </div>
        </div>
      </div>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopTally"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    // this.containerTracking();
    let payload = {
      excelId: "PENDING_REVERSE_BILLING_COUNT",
    };
    this.$store.dispatch("common/setAllPendingReverseTallyList", JSON.stringify(payload));
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason: "",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        {
          key: "ffInvoiceClosed",
          mainkey: "ffInvoiceClosed",
          label: "Execution Invoice",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },

        // {
        //   key: "tptInvoiceClosed",
        //   mainkey: "tptInvoiceClosed",
        //   label: "Invoice Status",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Billing",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "show_details",
        //   mainkey: "tptInvoiceClosed",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],

      InvoiceFields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "invoice_date",
          mainkey: "invoice_date",
          label: "Invoice Date ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "Status",
          mainkey: "status",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        // {
        //   key: "containerNo",
        //   mainkey: "containerNo",
        //   label: "Container",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "shipperInv",
        //   mainkey: "shipperInv",
        //   label: "Shipper Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },
        // {
        //   key: "ShippingB",
        //   mainkey: "ShippingB",
        //   label: "Shipping Bill",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "K.",
        // },

        // {
        //   key: "ffInvoiceClosed",
        //   mainkey: "ffInvoiceClosed",
        //   label: "Execution Invoice",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "Z.",
        // },

        // {
        //   key: "mainEnquiryId",
        //   mainkey: "mainEnquiryId",
        //   label: "Billing",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],

      // dateSearch: {
      //   fromDate: "",
      //   toDate: ""
      // },
      // eventId: "",
      syncFlag: false,
      invnoErrFlag: false,
      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      isLoadinghide:false,
      ExcelBtnName: "Export As Excel",
      ExcelContainerWiseBtnName: "Export ContainerWise Report",
      ExcelPendingReverseBtnName: "Export Pending Reverse Bill",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      CommonFilter: "",
      ContainerFilter: "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: "0",
      invstatusFilter: "1",
      assignstatusFilter: "0",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      shippmentDetails: [],
      invoiceTallyList: [],
      totalTallyCount: 0,
      clientMaster: [],
      reload: true,
      jobRecList: [
        { value: "0", text: "TPT Received" },
        { value: "1", text: "CC Received" },
        { value: "2", text: "FF Received" },
      ],

      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
        {
          inv: "3",
          int: "No-Billing",
        },
      ],
      invoiceStatusdataList: [
        {
          inv: "0",
          int: "All",
        },
        {
          inv: "1",
          int: "Active",
        },
        {
          inv: "2",
          int: "In-Active",
        },
      ],
      assignmentStatusdataList: [
        {
          inv: "0",
          int: "All",
        },
        {
          inv: "1",
          int: "Assignment Billing",
        },
        {
          inv: "2",
          int: "Direct Billing",
        },
        {
          inv: "3",
          int: "Third Party Billing",
        },
      ],
      InvItemist: [],
      Mtitle: "",
      modal_title: "",
      modal_JobNo: "",
      singleItem: {},
      InvItemSplitList:[],
      ExcelBSJBtnName:"Failed SE REPORT",
      ExcelJVBtnName:"JV REPORT",
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
    AssignmentSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    ClientCard,
    ShipmentTrackCard,
    CustomLoader,
  },

  computed: {},
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
    CommonFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.CommonFilter
        ) {
          this.statusFilter = "2";
        } else {
          this.statusFilter = "0";
        }
      },
      deep: true,
    },
  },
  methods: {
    newReverseTally(){
      this.$router.push({
        path: "/viewInvoiceDetails/newReverseTally",
      });
    },
    hideInvoiceDet() {
      this.Mtitle = "";
      this.singleItem = "";
      this.InvItemist = [];
      this.taxAmount = 0;
      this.$refs["otherTallyInvCharges-modal"].hide();
    },
    showInvoiceDet(item) {
      let moduleData = item.jobNo ? item.jobNo.split("/") : [];
      let itemObj = {
        allModuleId:
          item.allModuleId != undefined &&
          item.allModuleId != null &&
          item.allModuleId != "undefined" &&
          item.allModuleId != "null" &&
          item.allModuleId != ""
            ? item.allModuleId
            : moduleData.length > 0
            ? moduleData[3]
            : 0,
        jobNo: item.jobNo,
        invNo: item.BillingSeries,
        invDate: item.DocDtls_Dt,
        invType: item.DocDtls_Typ,
        itemCode: "getInvoiceItemSplitList",
      };
      this.Mtitle = "";
      this.Mtitle = "";
      this.singleItem = item;
      this.InvItemist = [];
      this.getInvItem(itemObj);
      this.modal_JobNo = item.jobNo;
      this.$refs["otherTallyInvCharges-modal"].show();
    },

    hideInvoiceSplitDet() {
      this.Mtitle = "";
      this.singleItem = "";
      this.InvItemSplitList = [];
      this.$refs["otherTallyInvSplitCharges-modal"].hide();
    },
    showInvoiceSplitDet(item) {
      // this.isLoadinghide = true;
      this.Mtitle = "";
      this.Mtitle = "";
      this.singleItem = item;
      this.InvItemSplitList = [];
      this.modal_JobNo = item.jobNo;
      this.InvItemSplitList = item.InvItemSplitList;
      if (this.InvItemSplitList.length === 0) {
        console.log("0");
      } else {
        console.log("1");
        this.isLoadinghide = false;
      }
      this.modal_title = " Item Splited List Inv No- " + item.InvDet.inv_no+" - JOB No- ";
      this.$refs["otherTallyInvSplitCharges-modal"].show();
    },
    getInvItem(itemObj) {
      this.InvItemist = [];

      this.isLoading = true;
      CommonService.getAllExpenseList(itemObj)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.InvList) {
              this.InvItemist = data.InvList.InvItemist;
            }
          } else {
            this.InvItemist = [];
          }

          this.modal_title = " Item List Inv No- " + itemObj.invNo+"- JOB No- ";
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllInvoiceList Error: ", error);
        });
    },
    // resetModal() {
    //       this.name = ''
    //       this.nameState = null
    //     },

    getReports(id, btnName) {
      var excelId = "INVOICE_BILLING";

      if (id == "INVOICE_BILLING") {
        excelId = "INVOICE_BILLING";
      } else if (id == "INVOICE_BILLING_CONTAINERWISE") {
        excelId = "INVOICE_BILLING_CONTAINERWISE";
      }
      let view_Assignment = {
        excelId: excelId,
        dateRange: this.dateRange,
        clientIdFilter: this.clientIdFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        invstatusFilter: this.invstatusFilter,
        assignstatusFilter: this.assignstatusFilter,
      };
      if (id == "INVOICE_BILLING") {
        this.ExcelBtnName = "Downloading Please Wait .....";
      } else if (id == "INVOICE_BILLING_CONTAINERWISE") {
        this.ExcelContainerWiseBtnName = "Downloading Please Wait .....";
      }

      CommonService.getAllPendingReverseTallyList(view_Assignment)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              if (id == "INVOICE_BILLING") {
                this.ExcelBtnName = btnName;
              } else if (id == "INVOICE_BILLING_CONTAINERWISE") {
                this.ExcelContainerWiseBtnName = btnName;
              }

              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },

    // getReports(id) {
    //   var excelId = "INVOICE_BILLING";

    //   if (id == "INVOICE_BILLING") {
    //     excelId = "INVOICE_BILLING";
    //   } else if (id == "INVOICE_BILLING_CONTAINERWISE") {
    //     excelId = "INVOICE_BILLING_CONTAINERWISE";
    //   }

    //   let view_Assignment = {
    //     excelId: excelId,
    //     dateRange: this.dateRange,
    //     clientIdFilter: this.clientIdFilter,
    //     ContainerFilter: this.ContainerFilter,
    //     shiperInvFilter: this.shiperInvFilter,
    //     InvoiceNoFilter: this.InvoiceNoFilter,
    //     invstatusFilter: this.invstatusFilter,
    //     assignstatusFilter: this.assignstatusFilter,
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if (status == 200 && data) {
    //         window.location.href =
    //           `https://uploadsp.pridel.com/Pridel_Reports/` +
    //           data.excelName;

    //         //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

    //         // console.log(abc)
    //       }
    //     })
    //     .catch((error) => {});
    // },
    getReportsReverse(id, btnName) {
      let excelIdGivin = "";
      if (id == "PENDING_REVERSE_BILLING") {
        excelIdGivin = "PENDING_REVERSE_BILLING";
      }
      let payload = {
        excelId: excelIdGivin,
      };
      this.ExcelPendingReverseBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelPendingReverseBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
        // alert(ExcelName)
        // if (ExcelName) {
        //   window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + ExcelName;
        // }
      }
    },
    containerTracking() {
      // alert("container tracking")
      // this.selectedAllModuleId = id;
      // this.isLoading=true

      // alert(this.ContainerFilter);

      let payload = {
        // containerId: this.ContainerFilter
        containerId: 1,
      };

      // console.log(this.$sessionsStorage.get("loginId"))

      console.log("Test => ", payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          alert(statusText + " : " + status + " : " + data);
          if (status == 200 && data) {
            //alert(data);

            console.log("Result => ", JSON.parse(data.data));

            data.data = JSON.parse(data.data);

            //alert(data.data);

            // this.trackingDetails = data.data;
            // console.log(this.trackingDetails);

            this.shippmentDetails.push(data.data);

            //  this.consoBooking.push(data.data);
            //this.shippmentDetails.push(1);

            // alert(this.shippmentDetails)

            console.log("Shippment Details => ", this.shippmentDetails);

            //  console.log(JSON.parse(data));
            // this.isLoading=false
          }
        })
        .catch((error) => {
          console.log("Err => ", error);
        });
    },
    validateBilling(id, jobType) {
      this.selectedAllModuleId = id;
      this.isLoading = true;

      let payload = {
        allModuleId: id,
        job: jobType,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.incompleteJobBill.length > 0) {
              this.incompleteJobBill = data.incompleteJobBill.toString();
            }
            this.$refs["modal-close-conf"].show();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    closeModalConfirm() {
      (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    getReports1(id) {
      this.isLoading = true;
      let excelIdGivin = "";
      if (id == "BILLING_SCREEN") {
        excelIdGivin = "BILLING_SCREEN";
      } else if (id == "BILLING_SCREEN_ALL") {
        excelIdGivin = "BILLING_SCREEN_ALL";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        CommonFilter: this.CommonFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              window.location.href =
                // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` +
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;

              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    showDocModal(item) {
      console.log("Summary & Docs => ", item);
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.jobNo;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    closeBill(id) {
      this.selectedAllModuleId = id;

      this.alert.content = "Are you sure to close Assignment Billing ?";
      this.$refs["addPopTally"].open();
    },
    closeBillOk(type) {
      if (this.closingReason) {
        this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
          closingReason: this.closingReason,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
      this.statusFilter = "";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.CommonFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.SBFilter = "";
      this.statusFilter = "0";
      this.invstatusFilter = "1";
      this.assignstatusFilter = "0";
      (this.dateRange = {
        startDate: "",
        endDate: "",
      }),
        this.viewFFExportFCL("0", "1", "1");
    },
    checkInvNoExistINReverseTallyBilling(item, mainSalesSeries, billingSeries) {
      // alert(item);
      // alert(mainSalesSeries);
      // alert(billingSeries);
      return new Promise((resolve) => {
        let InvDetails = {
          allModuleId: item,
          // 'mainSalesSeries':mainSalesSeries,
          billingSeries: billingSeries,
        };
        if (billingSeries != "") {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_Common/checkInvNoExistINReverseTallyBilling.php`,
            data: JSON.stringify(InvDetails),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }

                this.syncFlag = true;
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => {});
        }
      });
    },
    async proceedBilling(item, id, isConsolidation, mainSalesSeries, billingSeries) {
      this.$sessionsStorage.set("editSalesExId", item);
      if (billingSeries != "") {
        let checkValueExit = await this.checkInvNoExistINReverseTallyBilling(
          item,
          mainSalesSeries,
          billingSeries
        );
        console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          this.alert.content = "Invoice Details Not Avilable.";
          this.$refs["addPop"].open();
          return false;
        }
      }

      // iewBillingDetails/consolidation

      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          // path: "/allModuleForm/billing"
          path: "/consolidation/viewBillingDetails/" + item,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        if (id == "1") {
          this.$router.push({
            // path: "/allModuleForm/billing"
            path: "/allModuleForm/newTallyBillingMerge/" + item,
            query: { billingSeries: billingSeries },
          });
        } else {
          this.$router.push({
            // path: "/allModuleForm/billing"
            path: "/allModuleForm/invoiceBilling/" + item,
            query: { billingSeries: billingSeries },
          });
        }
      }
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },

    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    // goToMain() {
    //   this.$sessionsStorage.set("editallModuleId", "");
    //   this.$router.push({
    //     path: "/allModuleForm/allModuleForm"
    //   });
    // },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    getFailedSalesExpenseLogList(type) {
      let payload = {};
      this.ExcelBSJBtnName = "Downloading ....."
      payload = {
        itemCode: "getFailedSELogDetails",
        type: type,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.FailedSELogListFLAG == 1) {
            if (type == "Excell") {
            
              this.ExcelBSJBtnName = "Failed SE REPORT";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              
            }
          }
        })
        .catch((error) => {
          console.log("Catch on getFailedSalesExpenseLogList Error: ", error);
        });
    },

    getJVList(type) {
      let payload = {};
      this.ExcelJVBtnName = "Downloading ....."
      payload = {
        itemCode: "getJVIncomeLogDetails",
        type: type,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.JVListFLAG == 1) {
          if(data.JVList.length<=0){
            this.ExcelJVBtnName = "JV REPORT";
            this.alert.content = "SOrry Data Not Avilable.";
            this.$refs["addPop"].open();
          }
            if (type == "Excell" && data.JVList.length>0) {
            
              
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              
            }
          }
        })
        .catch((error) => {
          console.log("Catch on getJVList Error: ", error);
        });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.consoBooking = [];
      this.invoiceTallyList = [];
      this.totalTallyCount = 0;
      this.isLoading = true;
      let payload = {
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        CommonFilter: this.CommonFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        invstatusFilter: this.invstatusFilter,
        assignstatusFilter: this.assignstatusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
      };
      // console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/viewAllInvoiceList_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            console.log("MYDataArr=>", data);
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }

            if (data.assignmentData.length > 0) {
              this.invoiceTallyList = data.invoiceData;
              this.totalTallyCount = data.totalInvoiceData;
            } else {
              this.invoiceTallyList = [];
              this.totalTallyCount = 0;
            }

            console.log("Invoice count => ", this.totalTallyCount);

            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewInvoiceDetails.vue?1df07f8c